import React, {useState, useEffect} from 'react';
import ProductItem from '../../productList/ProductItem'
import {CLOTHING_PRODUCT_TEASER, JWELLERY_PRODUCT_TEASER, SHOES_PRODUCT_TEASER, ACCESSORIES_PRODUCT_TEASER} from '../../../components/Fragments/productTeaser'
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import {useFilterState, useFilterDispatch} from '../../Context/filterContext'
import {pagination} from '../../productList/pagination'
import Filters from '../../Filters/index'
import singleViewIcon from "../../../images/single-view.png";
import multipleViewIcon from "../../../images/multiple-view.png";
import { useGlobalDispatch } from '../../Context/globalContext';
import PriceFilter from '../../Filters/priceFilter';
import Loader from "react-loader-spinner";

const BoutiqueProductList = ({ boutiqueId, sortField, order }) => {
  const [filteredProdcut, setFilteredProducts] = useState([]);
  const filterDispatch = useFilterDispatch();
  const queryParams = {
    skip: 0,
    limit: 12
  };

  const [isSingleView, setIsSingleView] = useState(false);
  const [isMultipleView, setIsMultipleView] = useState(false);

  const singleView = () => {
    setIsSingleView(!isSingleView);
    setIsMultipleView(false);
  };

  const { withinStores, selectedCategory, selectedGender, listContext, isProductAvailable, selectedOrder } = useFilterState();
  let storeWithinRadius = [];

  if(boutiqueId) {
    storeWithinRadius = [boutiqueId]
    if(withinStores && !withinStores.includes(boutiqueId)){
      filterDispatch({type: 'storesFilter', payload: storeWithinRadius})
    }
  }

  if(selectedCategory && selectedCategory.length > 0 )
    queryParams.category = selectedCategory

  if(selectedGender && selectedGender.length > 0)
    queryParams.gender = selectedGender

  if(withinStores && withinStores.length > 0)
    queryParams.store = withinStores

  if(selectedOrder && Object.keys(selectedOrder).length > 0) {
    queryParams.order = [selectedOrder.order];
    queryParams.sortField = [selectedOrder.field];
  }
  const { loading, data, fetchMore } = useQuery(GET_ALL_PRODUCTS, {
    variables: queryParams
  });

  const globalDispatch = useGlobalDispatch();

  useEffect(() => {
    //setting boutique filter for BPL page
    if (listContext && !listContext.includes("boutique")) {
      filterDispatch({ type: 'listContextFilter', payload: "boutique" });
    }
   
    // TODO update with boutique's name
    globalDispatch({type: 'meta', payload: {pageTitle: 'Boutiques'}});

    if (order && sortField && selectedOrder && !Object.keys(selectedOrder).includes(order)) {
      filterDispatch({ type: 'productPriceFilter', payload: { field: sortField, order: order } });
    }
    if (!loading && data) {
      const {products} = data
      setFilteredProducts(products.nodes)
      filterDispatch({type: 'locationFilter', payload: true})
      filterDispatch({ type: 'setIsProductAvailable', payload: true });
    }else{
      filterDispatch({ type: 'setIsProductAvailable', payload: false });
    }
  }, [data])
  return (
    <>
    {
      isProductAvailable ? 
    <div className="product-list-page-wrapper">
        { (loading && filteredProdcut.length === 0) ? null : <Filters /> }
      <div className={`product-view ${isSingleView ? ' single-view' : isMultipleView ? 'multiple-view' : ''}`}>
        <span className="single-product-image"  onClick={() => singleView()}><img src={singleViewIcon} alt="Single Product view" /></span>
        <span className="multiple-product-image"  onClick={() => singleView()}><img src={multipleViewIcon} alt="Multiple product view" /></span>
      </div>
      <div className="product-list-container">
        <div className="cart-page-container">
          <h3>Products</h3>
          { (loading && filteredProdcut.length === 0) || <PriceFilter /> }  
        </div>
        <div className={`product-list-products ${isSingleView ? ' single-view' : isMultipleView ? 'multiple-view' : ''}`}>
          {(!loading && !filteredProdcut.length)
            ? <div className="text-light-black font-RocGrotesk text-center w-full p-10"><p>No products available for your search</p><a href="/boutiques">Click here to continue shopping</a></div>
            : filteredProdcut.map(item =>  <ProductItem key={item.drupal_id} product={item} />)}
        </div>
        <div className="product-list-button">
          {
            data && data.products && data.products.totalCount != data.products.nodes.length &&
            <button className="button-black" onClick={() => pagination(fetchMore, data.products.nodes.length, 12 )}>Load more</button>
          }
        </div>
      </div>
    </div>
    : <Loader
        type="Circles"
        color="#00BFFF"
        height={100}
        width={100}
        className="loader"
      />
    }
    </>
  )
}

export default BoutiqueProductList

const GET_ALL_PRODUCTS = gql`
  query($productTypeId: String, $store: [String], $category: [String], $gender: [String], $skip: Int, $limit: Int, $sortField: [commerceProductFieldsEnum] = [created], $order: [SortOrderEnum] = [DESC]) {
    products: allCommerceProduct(filter: {status: {eq: true}, relationships: {commerce_product_type: {drupal_id: {eq: $productTypeId}} ,stores: {elemMatch: {drupal_id: {in: $store}, field_published: {eq: true}}}, field_categories: {elemMatch: {name: {in: $category}, relationships: {parent: {elemMatch: {name: {in: $gender}}}}}}}}, skip: $skip, limit: $limit, sort: {fields: $sortField, order: $order} ) {
      totalCount
      pageInfo {
        pageCount
        currentPage
     }
      nodes {
        title
        drupal_id
        path{
          alias
        }
        relationships {
          field_categories {
            name
          }
          stores {
            drupal_id
          }
          variations {
            ...ClothingProductTeaser
            ...JewlleryProductTeaser
            ...ShoesProductTeaser
            ...AccessoriesProductTeaser
          }
      }
    }
    }
    stores: allCommerceStoreBoutique(filter: {field_published: {eq: true}}) {
      nodes {
        drupal_id
        field_geolocation {
          lat
          lng
        }
      }
    }
}  
${CLOTHING_PRODUCT_TEASER}
${JWELLERY_PRODUCT_TEASER}
${SHOES_PRODUCT_TEASER}
${ACCESSORIES_PRODUCT_TEASER}`
